/* eslint-disable import/first */
// COMMON //
import '../common';

// RAILS //
import Rails from '@rails/ujs';

// BOOTSTRAP
import { Dropdown } from '../javascript/bootstrap';

window.Dropdown = Dropdown;

// BOOTSTRAP-SELECT
require('bootstrap-select/js/bootstrap-select');

// PAPI
import { ApiList } from '../javascript/docs/api_list';
import { CardNav } from '../javascript/helper/card_nav';
import { ChangelogModal } from '../javascript/changelog/modal';
import { MailtoLink } from '../javascript/helper/mailto_link';
import { PasswordSwitcher } from '../javascript/helper/password_switcher';
import { ResourceList } from '../javascript/resources/resource_list';
import { ResourcePage } from '../javascript/resources/resource_page';
import { ToggleDisplay } from '../javascript/helper/toggle_display';

// STYLES //
import '../stylesheets/papi.scss';

// Rails ;)
Rails.start();

/*
const jQuery = require('jquery');

global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;
*/

ApiList.start();
CardNav.start();
ChangelogModal.start();
MailtoLink.start();
PasswordSwitcher.start();
ResourceList.start();
ResourcePage.start();
ToggleDisplay.start();
